package com.fireavert.auth.user_authentication.client.presentation

import com.fireavert.auth.shared.AuthErrorState

data class AuthViewState(
    val email: String = "",
    val password: String = "",
    val errorState: AuthErrorState = AuthErrorState(),
    val moveToDashboard: Boolean = false,
)